<template>
  <!-- TODO: make accessible -->
  <div class="loading-spinner">
    <span v-for="n in 8" :key="n" class="dot"></span>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
}
</script>

<style scoped>
.loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 2rem;
}

.dot {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 3px;
  height: 3px;
  background-color: #ffffff;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  animation: spin 1.2s var(--cubic-ease-in-out) infinite;
}

/* Generate 8 dots at equal angles */
.dot:nth-child(1) {
  transform: rotate(0deg) translate(10px) rotate(0deg);
  animation-delay: 0s;
}
.dot:nth-child(2) {
  transform: rotate(45deg) translate(10px) rotate(-45deg);
  animation-delay: 0.125s;
}
.dot:nth-child(3) {
  transform: rotate(90deg) translate(10px) rotate(-90deg);
  animation-delay: 0.25s;
}
.dot:nth-child(4) {
  transform: rotate(135deg) translate(10px) rotate(-135deg);
  animation-delay: 0.375s;
}
.dot:nth-child(5) {
  transform: rotate(180deg) translate(10px) rotate(-180deg);
  animation-delay: 0.5s;
}
.dot:nth-child(6) {
  transform: rotate(225deg) translate(10px) rotate(-225deg);
  animation-delay: 0.625s;
}
.dot:nth-child(7) {
  transform: rotate(270deg) translate(10px) rotate(-270deg);
  animation-delay: 0.75s;
}
.dot:nth-child(8) {
  transform: rotate(315deg) translate(10px) rotate(-315deg);
  animation-delay: 0.875s;
}

/* Rotating animation */
@keyframes spin {
  0% {
    opacity: 0.2;
    transform: rotate(0deg) translate(10px) rotate(0deg);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
    transform: rotate(360deg) translate(10px) rotate(-360deg);
  }
}
</style>
